const COMET_MCP_SOURCE_PREFIX = 'comet_mcp_';
export function isCometMcpSourceType(sourceType) {
    return sourceType.startsWith(COMET_MCP_SOURCE_PREFIX);
}
export function getCometMcpServerName(sourceType) {
    return sourceType.replace(COMET_MCP_SOURCE_PREFIX, '');
}
export function getCometMcpSourceType(serverName) {
    return `${COMET_MCP_SOURCE_PREFIX}${serverName}`;
}
//# sourceMappingURL=cometMcpSourceTypes.js.map